"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAttachmentFileId = void 0;
function extractAttachmentFileId(originalUrl) {
    // url like https://app.getmaintainx.com/api/s3/uploads/<file_id>
    const match = originalUrl.match(/\/api\/s3\/uploads\//);
    if (typeof (match === null || match === void 0 ? void 0 : match.index) === "number") {
        return originalUrl.slice(match.index + match[0].length);
    }
    return "";
}
exports.extractAttachmentFileId = extractAttachmentFileId;
//# sourceMappingURL=attachmentHelper.js.map